<template>
  <div>
    <template v-if="chain">

      <!-- header -->
      <div class="flex justify-between items-end mb-4">
        <h1 class="text-4xl font-bold tracking-tight text-gray-600">{{ chain.name }}</h1>
        <div class="flex items-end">
          <title-slot title="Har kapasitet?">
            <select class="bg-white flex" :class="{ 'text-gray-500': selectedStatus === '' }" v-model="selectedStatus">
              <option value="">Ingen filtrering</option>
              <option value="Ikke besvart" class="text-gray-900">Ikke besvart</option> <!--  ({{ unansweredCount }}) -->
              <option value="Ja" class="text-gray-900">Ja</option> <!--  ({{ yesCount }}) -->
              <option value="Nei" class="text-gray-900">Nei</option> <!-- ({{ noCount }}) -->
            </select>
          </title-slot>
          <title-slot class="ml-4" title="Fått student?" v-if="electionPeriod && electionPeriod.currentStep >= 7">
            <select class="bg-white flex" :class="{ 'text-gray-500': selectedCount === '' }" v-model="selectedCount">
              <option value="">Ingen sortering</option>
              <option value="Ja" class="text-gray-900">Ja</option> <!-- ({{ gotStudentsCount }}) -->
              <option value="Nei" class="text-gray-900">Nei</option> <!-- ({{ didNotGetStudentsCount }}) -->
            </select>
          </title-slot>
          <search-input class="ml-4" v-model="search"></search-input>
          <button class="btn btn-primary flex items-center ml-4" @click.prevent="onExport" :disabled="filteredPharmacies.length === 0">
            <font-awesome-icon :icon="['far', 'file-excel']" />
            <div class="ml-2">Excel</div>
          </button>
        </div>
      </div>

      <!-- <div class="py-2 px-4 rounded bg-gray-300 text-gray-600 font-bold uppercase text-sm" v-if="pharmacies.length > 0">
        Viser {{ filteredPharmacies.length }} apotek
      </div> -->

      <!-- stats -->
      <div class="flex items-center -mx-4 mt-10">
        <div class="w-1/5 px-4" v-for="(item, index) in statItems" :key="index">
          <div class="p-6 text-center rounded-lg leading-none" :class="{ 'bg-red-500': item.highlight, 'bg-gray-300': !item.highlight }">
            <div class="uppercase font-semibold text-sm" :class="{ 'text-red-300': item.highlight, 'text-gray-600': !item.highlight }">{{ item.title }}</div>
            <div class="text-6xl font-bold" :class="{ 'text-white': item.highlight, 'text-gray-700': !item.highlight }">{{ item.value }}</div>
          </div>
        </div>


      </div>

      <!-- table -->

      <panel class="mt-4">
        <data-table
          v-if="isReady"
          :headers="headers"
          :items="filteredPharmacies"
          @click="onClick"
          :search="search">
        </data-table>
        <div class="flex items-center p-4 text-gray-500 font-bold" v-else>
          <font-awesome-icon :icon="['far', 'spinner']" spin class="text-red-500" />
          <div class="ml-2">Laster apotek, vennligst vent ...</div>
        </div>
      </panel>



      <!-- details modal -->
      <modal v-if="selected" @close="selected = null" :header="selected.name">

        <image-carousel :images="selected.images"></image-carousel>

        <h2 class="text-xl font-semibold mt-6">Kontaktinfo</h2>
        <div class="flex flex-wrap whitespace-no-wrap">
          <div class="flex flex-row items-center mr-4 mt-2" v-if="selected.user && selected.user.name">
            <font-awesome-icon :icon="['far', 'user']"/>
            <div class="ml-1">{{ selected.user.name }}</div>
          </div>
          <div class="flex flex-row items-center mr-4 mt-2" v-if="selected.user && selected.user.phone">
            <font-awesome-icon :icon="['far', 'phone']"/>
            <a :href="'tel:' + selected.user.phone" class="text-red-500 ml-1">
              {{ selected.user.phone }}
            </a>
          </div>
          <div class="flex flex-row items-center mt-2" v-if="selected.user && selected.user.email">
            <font-awesome-icon :icon="['far', 'envelope']"/>
            <a :href="'mailto:' + selected.user.email" class="text-red-500 ml-1">{{ selected.user.email }}</a>
          </div>
        </div>

        <h2 class="text-xl font-semibold mt-6">Har kapasitet?</h2>
        <div class="italic" v-if="selected.status">{{ selected.status.text }}. {{ selected.status.created }}</div>
        <div class="italic" v-else>Ikke besvart.</div>

        <template v-if="selected.slots.length > 0">
          <h2 class="text-xl font-semibold mt-6">Plasser</h2>
          <table class="mt-1 bg-gray-200">
            <tr>
              <td class="py-1 px-3 font-bold">#</td>
              <td class="py-1 px-3 font-bold">Studie</td>
              <td class="py-1 px-3 font-bold">Universitet</td>
              <td class="py-1 px-3 font-bold">Tildelt</td>              
            </tr>
            <tr 
              v-for="(slot, index) in selected.slots" 
              :key="index"
              :class="{
                'bg-gray-300': index % 2 === 0
              }"
            >
              <td class="py-1 px-3">{{ index + 1 }}</td>
              <td class="py-1 px-3">{{ slot.studyDisplay || "Ikke begrenset" }}</td>
              <td class="py-1 px-3">{{ slot.university || "Ikke begrenset" }}</td>
              <td class="py-1 px-3">
                <template v-if="slot.student">
                  {{ slot.student.name }}<br/>
                  <a class="text-red-500" :href="'mailto:' + slot.student.email">{{ slot.student.email }}</a><br/>
                  {{ slot.student.university }}<br/>
                  Prioritet: {{ slot.student.wishPriority.length > 0 ? slot.student.wishPriority[0] : 'N/A' }}
                </template>
              </td>
            </tr>
          </table>          
        </template>

        <div class="mt-8">
          <div v-html="selected.description"></div>
        </div>

      </modal>
    </template>
  </div>
</template>

<script>
import ImageCarousel from '@/components/ImageCarousel.vue'
import api from '@/api'
import { filter, forEach, get, sumBy } from 'lodash'
export default {
  name: 'kk-home',
  components: {
    ImageCarousel
  },
  data () {
    return {
      isReady: false,
      selected: null,
      electionPeriod: null,
      selectedStatus: '',
      selectedCount: '',
      search: '',
      headers: [],
      chain: null,
      pharmacies: []
    }
  },
  computed: {
    filteredPharmacies () {
      return filter(this.pharmacies, p => {
        return (this.selectedStatus === '' || this.selectedStatus === p.status) &&
               (this.selectedCount === '' || this.selectedCount === p.gotStudents)
      })
    },
    respondedCount () {
      // return filter(this.pharmacies, c => c.responded).length
      return filter(this.pharmacies, c => c.response).length
    },
    notRespondedCount () {
      // return filter(this.pharmacies, c => c.responded == false).length
      return filter(this.pharmacies, c => !c.response).length
    },
    respondedYesCount () {
      return filter(this.pharmacies, c => c.respondedYes).length
    },
    respondedNoCount () {
      return filter(this.pharmacies, c => c.respondedNo).length
    },
    slotCountTotal () {
      return sumBy(this.pharmacies, c => c.slotCount)
    },
    statItems () {
      return [
        { title: 'Antall apotek', value: this.pharmacies.length, highlight: false },
        { title: 'Ikke besvart', value: this.notRespondedCount, highlight: this.selectedStatus == 'Ikke besvart' },
        { title: 'Besvart', value: this.respondedCount, highlight: false },
        { title: 'Svart JA', value: this.respondedYesCount, highlight: this.selectedStatus == 'Ja' },
        { title: 'Svart NEI', value: this.respondedNoCount, highlight: this.selectedStatus == 'Nei' },
        { title: 'Antall plasser', value: this.slotCountTotal, highlight: false },
      ]
    }

  },
  methods: {
    async onClick (pharmacy) {
      this.selected = await api.kk.getPharmacy(pharmacy.pharmacyId)
    },
    onExport () {
      api.kk.export()
    }
  },
  async created () {
    this.chain = await api.kk.getChain()
    this.electionPeriod = await api.kk.getElectionPeriod()

    if (this.electionPeriod && this.electionPeriod.currentStep < 7) {
      this.headers = [
        { text: 'Apotek', align: 'left', value: 'name' },
        { text: 'E-post', align: 'left', value: 'email' },
        { text: 'Har kapasitet?', align: 'center', value: 'status', nowrap: true },
        { text: 'Antall plasser', align: 'center', value: 'slotCount', nowrap: true },
        { text: 'Svardato', align: 'center', value: 'created', nowrap: true }
      ]
    } else {
      this.headers = [
        { text: 'Apotek', align: 'left', value: 'name' },
        { text: 'E-post', align: 'left', value: 'email' },
        { text: 'Har kapasitet?', align: 'center', value: 'status', nowrap: true },
        { text: 'Antall plasser', align: 'center', value: 'slotCount', nowrap: true },
        { text: 'Svardato', align: 'center', value: 'created', nowrap: true },
        { text: 'Fått student?', align: 'center', value: 'gotStudents' }
      ]
    }

    const pharmacies = await api.kk.getPharmacies()

    forEach(pharmacies, pharmacy => {

      var isAvailable = get(pharmacy, "response.isAvailable")
      var created = get(pharmacy, "response.created")

      pharmacy.status = isAvailable === true ? "Ja" :
                        isAvailable === false ? "Nei" : "Ikke besvart"
            
      pharmacy.created = created ? created.substr(0, 10) : ""

      pharmacy.respondedYes = isAvailable === true
      pharmacy.respondedNo = isAvailable === false

      pharmacy.gotStudents = pharmacy.studentCount > 0 ? "Ja" : "Nei"      
    })

    this.pharmacies = pharmacies;

    this.isReady = true
  }
}
</script>